import { Link } from 'react-router-dom';

const CABIN_TYPES = [
  {
    icon: 'ri-vip-crown-line',
    title: 'Luxury Cabins',
    desc: 'Upscale mountain retreats with premium finishes, stone fireplaces, gourmet kitchens, and covered outdoor living spaces. Ideal for couples and families seeking a refined escape.',
    link: '/best-luxury-cabins',
    linkLabel: 'View Luxury Cabins',
  },
  {
    icon: 'ri-heart-line',
    title: 'Pet-Friendly Cabins',
    desc: 'Cabins that welcome your four-legged family members. Wooded settings, nearby trails, and outdoor spaces make Highlands one of the best destinations for traveling with pets.',
    link: '/pet-friendly-cabins-highlands-nc',
    linkLabel: 'View Pet-Friendly Cabins',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Cabins Near Waterfalls',
    desc: 'Stay within minutes of Glen Falls, Dry Falls, and Bridal Veil Falls. These cabins offer unmatched access to Highlands\' most iconic natural landmarks.',
    link: '/cabins-near-glen-falls-highlands-nc',
    linkLabel: 'View Waterfall Cabins',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Close to Downtown',
    desc: 'Walk or drive just minutes to Highlands\' acclaimed restaurants, boutique shops, art galleries, and the Saturday Farmers Market. Convenience without sacrificing privacy.',
    link: '/best-luxury-cabins',
    linkLabel: 'Browse All Cabins',
  },
];

export default function CabinTypesSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Find Your Perfect Stay</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-5">
            Types of Cabins<br /><em className="italic">in Highlands, NC</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto">
            Whether you&apos;re looking for a luxury retreat, a pet-friendly escape, or a cabin steps from a waterfall, Highlands has options to match every style of travel.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {CABIN_TYPES.map((type) => (
            <div key={type.title} className="bg-white rounded-2xl p-8 flex flex-col">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className={`${type.icon} text-[#2D4A3E] text-xl`} />
              </div>
              <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-3">{type.title}</h3>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed flex-1 mb-6">{type.desc}</p>
              <Link
                to={type.link}
                className="inline-flex items-center gap-2 text-[#2D4A3E] text-xs font-jost tracking-[0.15em] uppercase hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                {type.linkLabel}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
